import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_HOST;




export const getFAQ = async ({ page = 1, limit = 10 }) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/faq`, {
    params: { page, limit },
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });


  const resData = response.data.data;

  return {
    blogs: resData.data,
    currentPage: resData.current_page,
    lastPage: resData.last_page,
    perPage: resData.per_page,
    total: resData.total,
    nextPageUrl: resData.next_page_url,
    prevPageUrl: resData.prev_page_url,
  };
};


export const addFAQ = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/faq/add`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const updateFAQ = async (formData) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.post(`${API_BASE_URL}/faq/update`, formData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const getFAQById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/faq/show/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};

export const deleteFAQById = async (id) => {
  const token = localStorage.getItem("access_token");
  const response = await axios.get(`${API_BASE_URL}/faq/delete/${id}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return response.data;
};


